import moment from 'moment';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('currentUserModule', ['getParentId', 'getRecipientType', 'getPeriodsActsGenerate']),
  },
  methods: {
    shouldShowActButton(userType = 0) {
      // 0 = fiz, 1 = Fop, 2 = Tov
      const userTypeIds = userType !== 0 ? [1, 2] : [0, 4]; // was [0] for fiz
      if(! userTypeIds.includes(this.getRecipientType) || this.getParentId) {
        return false;
      }

      const today = moment();
      const currentMonth = today.month(); // 0-11
      const currentYear = today.year();

      const prevMonth = moment(today).subtract(1, 'month');
      const prevMonthNumber = prevMonth.month();
      const prevYear = prevMonth.year();

      // Получаем все возможные даты активации: за текущий и предыдущий месяц
      const triggerDays = [
        ...this.getTriggerDays(this.getPeriodsActsGenerate, prevYear, prevMonthNumber),
        ...this.getTriggerDays(this.getPeriodsActsGenerate, currentYear, currentMonth),
      ];

      return triggerDays.some(triggerDate => {
        const start = moment(triggerDate).startOf('day');
        const end = this.addBusinessDays(start, 2).endOf('day'); // 2 рабочих дня
        return today.isSameOrAfter(start) && today.isBefore(end);
      });
    },
    addBusinessDays(startDate, numberOfDays) {
      let current = moment(startDate);
      let addedDays = 0;

      while (addedDays < numberOfDays) {
        current = current.add(1, 'day');
        const day = current.isoWeekday(); // 1 = Пн, 7 = Вс
        if (day >= 1 && day <= 5) {
          addedDays++;
        }
      }

      return current;
    },
    getTriggerDays(period, year, month) {
      const dates = [];
      const lastDayOfMonth = moment({ year, month }).daysInMonth();

      if (period === 10) {

        dates.push(moment({ year, month, day: 10 }));
        dates.push(moment({ year, month, day: 20 }));
        if (lastDayOfMonth > 30) {
          // Если 31 день → берём 30-е число
          dates.push(moment({ year, month, day: 30 }));
        } else {
          // Иначе — последний день месяца
          dates.push(moment({ year, month }).endOf('month'));
        }
      }

      if (period === 15) {

        dates.push(moment({ year, month, day: 15 }));

        if (lastDayOfMonth > 30) {
          // Если 31 день → берём 30-е число
          dates.push(moment({ year, month, day: 30 }));
        } else {
          // Иначе — последний день месяца
          dates.push(moment({ year, month }).endOf('month'));
        }

      }

      if (period === 30) {
        dates.push(moment({ year, month }).endOf('month'));
      }

      return dates;
    },
  },
};
